import classes from './ChatAi.module.css'
import Transcript from './transcript/Transcript';
import MessageLine from './messageLine/MessageLine';
import useLmsAction from '../../../hooks/useLmsAction';
import objectsNameTypes from '../../../enums/objectsNameTypes';
import ChatActions from './chatActions/ChatActions';
import { useState } from 'react';
import ShareBubble from './chatActions/shareBubble/ShareBubble';
import ReportBubble from './chatActions/reportBubble/ReportBubble';
import RefreshBubble from './chatActions/refreshBubble/RefreshBubble';
import { useDispatch, useSelector } from 'react-redux';
import { chatActions } from '../../../store/chatAi-slice';
import ChatAlert from './chatActions/chatAlert/ChatAlert';
import { useNavigate } from 'react-router';


function ChatAi() {
    useLmsAction(window.location.href,objectsNameTypes.bina);

    const [shareState, setShareState] = useState(false)
    const [reportState, setReportState] = useState(false)
    const [refreshState, setRefreshState] = useState(false)


    let switchShare = (value) => {
        setShareState(value)
    }
    let switchReport = (value) => {
        setReportState(value)
    }
    let switchRefresh = (value) => {
        setRefreshState(value)
    }

    let shareBubble = null;
    if (shareState) {
        shareBubble = (<ShareBubble onClose={() => switchShare(false)}/>)
    }
    let reportBubble = null;
    if (reportState) {
        reportBubble = (<ReportBubble onClose={() => switchReport(false)}/>)
    }
    let refreshBubble = null;
    if (refreshState) {
        refreshBubble = (<RefreshBubble onClose={() => switchRefresh(false)}/>)
    }

    return (
        <div className={classes.ChatAi}>
            <Transcript/>
            <MessageLine />
            <ChatActions onShare={() => switchShare(true)} onReport={() => switchReport(true)} onRefresh={() => switchRefresh(true)}/>
            {shareBubble}
            {reportBubble}
            {refreshBubble}
        </div>
    );
}

export default ChatAi;